import { useQuery } from '@tanstack/react-query';
import { fetchAllStatesList } from '../data-provider/state-list';
import type { AllStatesListRequestParams } from '../data-provider/state-list/api';

export const useGetStateList = ({
  isDisabled,
  ...params
}: Partial<AllStatesListRequestParams> & { isDisabled: boolean }) => {
  return useQuery({
    queryKey: ['all-state-list', params.CountryCode],
    queryFn: () => fetchAllStatesList(params as AllStatesListRequestParams),
    staleTime: Number.POSITIVE_INFINITY, // loaded only once
    enabled: !!params.CountryCode && !isDisabled,
  });
};
